import APIClient from './APIClient';

class ReminderService extends Object {
    async setReminder(data: any, token: string) {
        const response = await APIClient.post(`remind`, data, token);
        return response;
    }
}
export default new ReminderService();
